import type { ComponentType, ReactElement } from 'react';

import { AuthLayout } from './authLayout.page';

export const withAuthLayout = <P extends object>(WrappedComponent: ComponentType<P>) => {
    return (props: P): ReactElement => {
        return (
            <AuthLayout>
                <WrappedComponent {...props} />
            </AuthLayout>
        );
    };
};
